import React, {useCallback, useContext, useEffect, useState} from 'react';
import {FormProvider, useForm} from "react-hook-form";
import clsx from "clsx";
import {Card, CardActions, CardContent, CardHeader, Grid, Tooltip, Typography} from "@mui/material";
import Button from "@mui/material/Button";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {AnagraficaCompleta} from "../../../widgets/common/AnagraficaCompleta";
import {AnagraficaContext, AppContext} from "../../../../App";
import {addAnagrafica} from "../../../../services/AnagraficaServices";
import {getAnaGraficaApi} from "../../../../services/utils/TicketApiData";
import {setOpenSnackbar} from "../../../../services/AppServices";

const CreaAnagraficaCard = () => {
	const classes = BaseStyle();
	const anagraficaContext = useContext(AnagraficaContext);
	const appContext = useContext(AppContext);
	const methods = useForm({mode: "onChange",});
	const [submit, setSubmit] = useState(false);
	
	const onSubmit = useCallback((data) => {
		setSubmit(true);
		addAnagrafica(getAnaGraficaApi(data), anagraficaContext.dispatch);
	}, [anagraficaContext.dispatch]);
	
	useEffect(() => {
		if (submit && !anagraficaContext.state.loadingAddAnagrafica && anagraficaContext.state.errorAddAnagrafica === "") {
			setSubmit(false);
			setOpenSnackbar("success", "Anagrafica creata correttamente", appContext.dispatch);
		} else if (submit && !anagraficaContext.state.loadingAddAnagrafica && anagraficaContext.state.errorAddAnagrafica !== "") {
			setSubmit(false);
			setOpenSnackbar("success", anagraficaContext.state.errorAddAnagrafica, appContext.dispatch);
		}
	}, [submit, anagraficaContext.state.loadingAddAnagrafica, anagraficaContext.state.errorAddAnagrafica, appContext.dispatch])
	
	return (
		<React.Fragment>
			<Card className={clsx(classes.roundBorder, classes.transparent)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<FormProvider {...methods} >
					<form onSubmit={methods.handleSubmit(onSubmit)}>
						<CardHeader
							title={<Typography variant={"h6"}><b>Crea un Anagrafica</b></Typography>}
							subheader={"Segui le indicazioni per creare un Anagrafica da zero."}
						/>
						<CardContent style={{flexGrow: 1}}>
							<Grid container spacing={3}>
								<AnagraficaCompleta classes={classes} intro={"false"} moreInfo={true}/>
							</Grid>
						</CardContent>
						<CardActions className={classes.flexRight}>
							<Tooltip
								title={"Dopo aver controllato minuziosamente ogni singolo dato inserito, clicca su conferma per inviarlo al server che farà le magie."}>
								<Button variant={"contained"} disableElevation size="small" color="primary"
								        style={{borderRadius: 24}}
								        className={classes.roundButton} onClick={methods.handleSubmit(onSubmit)}>
									<b>Conferma e crea</b>
								</Button>
							</Tooltip>
						</CardActions>
					</form>
				</FormProvider>
			</Card>
		</React.Fragment>
	);
};

export default React.memo(CreaAnagraficaCard)
